import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { SelectField } from "ui-components/Form";

import { FormTitle, Text } from "ui-components/Form";

function WarehouseInfo({ formRender, control, errors, mode = "ADD" }) {
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Warehouse Information" : "Warehouse Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { editable, ...data } = property;
              const xs = 12 / rows.length;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };

              return (
                <Grid item xs={xs} key={index}>
                  {data.type === "select" ? (
                    <SelectField
                      field={fieldProps}
                      options={[
                        "Quarantine",
                        "Return",
                        "Shipping",
                        "Staging",
                        "Storage",
                        "Variance",
                        "Scrap",
                      ]}
                    />
                  ) : (
                    <Text field={fieldProps} />
                  )}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default WarehouseInfo;
